import { Component, Input } from '@angular/core';

@Component({
  selector: 'afp-label-card',
  templateUrl: './label-card.component.html',
  styleUrls: ['./label-card.component.scss']
})
export class LabelCardComponent {
  @Input() label: string = '';
}
